<template>
  <ValidationProvider :rules="rules" v-slot="{ errors, valid }" :name="errorLabelText">
    <b-field :label="label" :type="{'is-danger': errors.length }" :message="errors[0]">
      <date-picker
        :input-class="'input'"
        v-model="data"
        :placeholder="placeholder"
        :use-utc="false"
        :format="'dd-MM-yyyy'"
        :disabled="disabled"
        @selected="emitInput"
        :disabledDates="disabledDates"
      ></date-picker>
    </b-field>
  </ValidationProvider>
</template>

<script>
import DatePicker from "vuejs-datepicker";
import { ValidationProvider } from "vee-validate";
import * as moment from "moment";

/**
 * Custom Form input with validation setup
 */
export default {
  name: "DateInputWithValidation",
  props: {
    rules: { type: String, required: true },
    model: { type: String | Boolean },
    label: { type: String, default: "Select a Date" },
    vuexKey: { type: String, required: true },
    name: { type: String, required: true },
    errorLabel: { type: String },
    placeholder: { type: String, required: true },
    disabled: { type: Boolean, default: false },
    disabledDates: {type: Object},
    minDate: {
      type: Date,
      default: () => {
        const today = new Date();
        return new Date(today.getFullYear(), today.getMonth(), today.getDate());
      }
    }
  },

  components: {
    ValidationProvider,
    DatePicker
  },

  data() {
    return {
      data: this.model
    };
  },

  computed: {
    /**
     * Determine the text to be used as the field name when displaying error messages
     */
    errorLabelText() {
      if (this.errorLabel) {
        return this.errorLabel;
      }

      return this.name;
    }
  },

  methods: {
    emitInput: function(value) {
      // let date = moment(value)
      //   .utc()
      //   .format("YYYY-MM-DD");

      let date = moment(value).format("YYYY-MM-DD");

      this.$emit("input", {
        key: this.vuexKey,
        value: date
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.dropdown.is-disabled {
  opacity: 1 !important;
  background-color: red;
}
.datepicker {
  opacity: 1;
  background-color: #ffffff;
  border: 1px solid #ccc;
}
</style>
